import { render } from "./DestinationGroupCard.vue?vue&type=template&id=f03ce298"
import script from "./DestinationGroupCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DestinationGroupCard.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ui/PlatformList/DestinationGroupCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f03ce298"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f03ce298', __exports__)) {
    api.reload('f03ce298', __exports__)
  }
  
  module.hot.accept("./DestinationGroupCard.vue?vue&type=template&id=f03ce298", () => {
    api.rerender('f03ce298', render)
  })

}


export default __exports__